import { render } from "./Header.vue?vue&type=template&id=dd85a884"
const script = {}
script.render = render

export default script